(function ($, wxpHelpers, wgsdk) {
    'use strict';

    var NAV_SUB_MENU_SELECTOR = '.js-nav-submenu';
    var MOBILE_NAV_SUB_MENU_SELECTOR = '.js-nav';
    var CONTAINER_SELECTOR = '.js-autocomplete-container';
    var JS_LAYOUT_SELECTOR = '.js-layout';
    var AUTOCOMPLETE_NAMESPACE = '.autocomplete';
    var AUTOCOMPLITE_LINE_SELECTOR = '.js-autocomplete';
    var AUTOCOMPLITE_LINE_CLASS = 'js-autocomplete';
    var AUTOCOMPLITE_ITEM_CLASS = 'b-autocomplete_item';
    var AUTOCOMPLITE_ITEM_SELECTOR = '.' + AUTOCOMPLITE_ITEM_CLASS;
    var AUTOCOMPLETE_SELECTED_CLASS = 'b-autocomplete_item__selected';
    var AUTOCOMPLETE_SELECTED_SELECTOR = '.' + AUTOCOMPLETE_SELECTED_CLASS;
    var globalAutocompleteCounter = 0;
    var KEY_BACKSPACE = 8;
    var KEY_TAB = 9;
    var KEY_ENTER = 13;
    var KEY_ESCAPE = 27;
    var KEY_DOWN = 40;
    var KEY_UP = 38;
    var ON_BLUR_HIDE_TIMEOUT = 50;

    /**
     * scrolling page to target element
     *
     * @param target {jquery object}
     * @param options {object}
     */
    wxpHelpers.scrollTo = function (target, options) {
        var $target = $(target),
            targetTopOffset,

            $navMenu = $(NAV_SUB_MENU_SELECTOR + ':visible, ' + MOBILE_NAV_SUB_MENU_SELECTOR + ':visible'),
            menuOffset,
            defaults = {
                scrollDuration: 100,
                scrollTopOffset: 0
            };

        options = $.extend({}, defaults, options);

        if ($navMenu.length && $target.length) {
            menuOffset = ($navMenu.position().top + $navMenu.height());

            setTimeout(function () {
                if ($.browser.mobile && $.browser.iemobile) {
                    $target.get(0).scrollIntoView();
                } else {
                    targetTopOffset = ($target.offset().top - options.scrollTopOffset);

                    if ($navMenu.css('position') === 'fixed') {
                        targetTopOffset -= menuOffset;
                    }

                    $('html,body').stop().animate({
                        scrollTop: targetTopOffset
                    }, options.scrollDuration);
                }
            }, 10);
        }
    };

    wxpHelpers.autocomplete = function (inputSelector, url, options) {

        var defaults = {
            'clearSelector': null,
            'autosubmit': false, /* Submit form on click/enter */
            'autoApply': true, /* set textbox value to clicked elements */
            'autoSelectExactMatch': false,
            'minlength': 0,
            'preprocessor': function (value, prefix) {
                value = $.trim(value);
                prefix = $.trim(prefix);
                var matchedSubstrIndex = value.toLowerCase().indexOf(prefix.toLowerCase());
                value = value.substr(0, matchedSubstrIndex) + '<span class="b-autocomplete_match">' + value.substr(matchedSubstrIndex, prefix.length) + '</span>' + value.substr(matchedSubstrIndex + prefix.length);
                return value;
            },
            'zindex': null,
            'customWrapper': null,
            'itemRenderedHandler': null,
            'dataprocessor': null, /* AJAX params processor before send */
            'changeCallback': null,
            'responseDataPreprocessor': null,
            'changeLocation': null,
            'template': $('<div>'),
            'viewallElement': $(),
            'noResultsElement': $(),
            'selectedHandler': null,
            'clearHandler': null,
            'platform':null,
        };
        options = $.extend({}, defaults, options);

        var autocompleteContainerId = 'js-autocomplete-container-' + (++globalAutocompleteCounter);
        var $body = $('body');
        var $layout = $(JS_LAYOUT_SELECTOR);
        var $input;
        var $clear;
        var $lines;
        var $wrapper;
        var $wrapperContainer;
        var $template;
        var watcher;
        var fetcher;
        var searchValue;
        var $form;
        var $window = $(window);
        var $viewAll = options.viewallElement;
        var $noResults = options.noResultsElement;
        var itemRenderedHandler = options.itemRenderedHandler;
        var selectedHandler = options.selectedHandler;
        var clearHandler = options.clearHandler;
        var shouldAttemptAutoSelect = false;
        var skipFocusHandler = false;
        var platform = options.platform;


        $template = defaults.template;

        function getItemContainer() {
            if (options.customWrapper === null) {
                return $wrapper;
            } else {
                return $wrapperContainer;
            }
        }

        function updatePosition() {
            var inputOffset = $input.offset();

            var ancestorFixed = false;
            $input.parents().each(function () {
                ancestorFixed = ancestorFixed || ($(this).css('position') == 'fixed');
            });

            if (ancestorFixed) {
                $wrapper.css({'position': 'fixed'});
                inputOffset.top -= $window.scrollTop();
                inputOffset.left -= $window.scrollLeft();
            }

            $wrapper
                .outerWidth($input.outerWidth())
                .css({
                    'top': inputOffset.top + $input.outerHeight(),
                    'left': inputOffset.left,
                    'width': $input.outerWidth(),
                });

            function resizeList() {
                var $lines = $(AUTOCOMPLITE_LINE_SELECTOR).show();
                var len = $lines.length;
                var scrollTop = $body.scrollTop() + $window.scrollTop();
                var spaceMax = Math.floor((($window.height() - $input.outerHeight() - inputOffset.top + scrollTop)) / $lines.first().outerHeight());
                var settingMax = window.MAX_SUGGESTS_COUNT;
                var showViewall = false;

                if (len >= settingMax) {
                    showViewall = true;
                }
                if (!showViewall && len <= spaceMax) {
                    showViewall = showViewall || false;
                } else {
                    showViewall = true;
                    $lines.slice(Math.max(spaceMax - 1, 0)).hide();
                }
                $viewAll.toggle(showViewall);
            }

            if ($lines.first().height() == 0) {
                setTimeout(resizeList, 0);
            } else {
                resizeList();
            }
        }

        function getSelected(ev) {
            var hovered = $(AUTOCOMPLETE_SELECTED_SELECTOR + ':first');
            if (hovered.length || !ev)
                return hovered;
            else
                return $(ev.target).closest(AUTOCOMPLITE_ITEM_SELECTOR);
        }

        function setSelected($sel) {
            getSelected().removeClass(AUTOCOMPLETE_SELECTED_CLASS);
            if ($sel) {
                $sel.addClass(AUTOCOMPLETE_SELECTED_CLASS);
            }
        }

        function updateInputWithSelected(applyFilter) {
            var $sel = getSelected();

            if ($sel.length) {
                var text = $sel.text();
                watcher.setValue(text, applyFilter);
                $input[0].setSelectionRange(0, text.length);
                if (typeof options.changeCallback === 'function') {
                    options.changeCallback();
                }
            }
        }

        function restoreInput() {
            watcher.restoreValue();
            if (typeof options.changeCallback === 'function') {
                options.changeCallback();
            }
        }

        function isSuggestionVisible() {
            return $wrapper.css('display') !== 'none';
        }

        function setVisibility(shouldShow) {
            if (!$wrapper)
                return; // not yet initialized, nothing to show or hide

            if (shouldShow)
                updatePosition();

            if (shouldShow !== isSuggestionVisible()) {
                if (shouldShow && (($lines && $lines.length) || $noResults.length > 0)) {
                    $wrapper.show();
                    $layout.on('click' + AUTOCOMPLETE_NAMESPACE, function (e) {
                        var $clickedElement = $(e.target);

                        if (!$clickedElement.is(inputSelector)) {
                            hideAutocomplete();
                        }
                    });
                    $(window).on('resize orientationchange scroll', updatePosition);

                } else {
                    $wrapper.hide();
                    //$input.off('blur' + AUTOCOMPLETE_NAMESPACE);
                    $layout.off('click' + AUTOCOMPLETE_NAMESPACE);
                    $(window).off('resize orientationchange scroll', updatePosition)
                }
            }
        }

        function applySelected() {
            fetcher.cancelRequest();
            updateInputWithSelected(true);
            setVisibility(false);

            // value was set by .val() call, which doesn't trigger change event
            $input.change();
        }

        function hideAutocomplete() {
            fetcher.cancelRequest();
            if (isSuggestionVisible()) {
                setTimeout(function () {
                    setVisibility(false);
                }, ON_BLUR_HIDE_TIMEOUT);   // give some time to process click on suggestion element
            }
        }

        function onRequestComplete(data) {
            var i;
            var content;
            var $newElement;

            if (typeof options.responseDataPreprocessor === 'function') {
                data = options.responseDataPreprocessor(data);
            }

            if (data && data.result) {

                getItemContainer().empty();

                $(AUTOCOMPLITE_LINE_SELECTOR).remove();


                var len = data.result.length;

                for (i = 0; i < len; ++i) {
                    content = data.result[i].text;
                    if (typeof options.preprocessor === 'function') {
                        content = options.preprocessor(content, searchValue);
                    }
                    $newElement = $template.clone().addClass(AUTOCOMPLITE_LINE_CLASS + ' ' + AUTOCOMPLITE_ITEM_CLASS).html(content).show();

                    getItemContainer().append($newElement);
                    if (typeof itemRenderedHandler === 'function') {
                        itemRenderedHandler(content, searchValue);
                    }
                }
                $lines = $(AUTOCOMPLITE_LINE_SELECTOR);

                if (len > 0) {
                    $lines.hover(
                        function (e) {
                            setSelected($(this));
                        },
                        function (e) {
                            setSelected(null);
                        }
                    );


                    selectExactMatch();

                    var selected = getSelected();
                    if (shouldAttemptAutoSelect) {
                        fireSelected(selected);
                    }
                    shouldAttemptAutoSelect = false;

                }


                setVisibility(len > 0 || $noResults.length > 0);
                $noResults.toggle(len == 0);

            }
        }

        function preventAutocomplete() {
            fetcher.cancelRequest();
            setVisibility(false);
        }

        function destroy() {
            preventAutocomplete();
            if ($input.length) {
                $wrapper.remove();
                $input.off(AUTOCOMPLETE_NAMESPACE);
                $input.parents('form:first').off(AUTOCOMPLETE_NAMESPACE);
            }
            if (watcher) {
                watcher.destroy();
            }
        }

        var selectExactMatch = function () {
            if ($lines && $lines.length) {
                var $match = $lines.filter(function (i, e) {
                    return $(e).text().trim() == searchValue.trim();
                }).last();
                if ($match.length)
                    setSelected($match);
            }
        };

        var fireSelected = function (e) {
            var handled = false;
            if (typeof(selectedHandler) == 'function') {
                if (selectedHandler(getSelected())) {
                    e.preventDefault();
                    handled = true;
                }
            } else if (selectedHandler) {
                console.error("selectedHandler must be a function");
            }
            return handled;
        };

        function changeLocation(e) {
            var possibleUrl = $(e.currentTarget)
                .find('[data-url]')
                .add(e.currentTarget)
                .filter('[data-url]')
                .data('url');

            if (possibleUrl) {
                top.location.href = possibleUrl;
                setTimeout(function () {
                    top.location.href = possibleUrl;
                }, 1);
                return false;
            }
        }

        function onValueChange(value, oldValue) {
            var data = {'fl': value, 'platform': platform};

            if (value.length === 0 || value.length < options.minlength) {
                fetcher.cancelRequest();
                setVisibility(false);
                return;
            }

            searchValue = value;
            selectExactMatch();


            // Fetcher normally cancels existing requests when sendRequest is called (see below)
            // However, we are depending on cancelRequest to trigger the onRequestComplete, causing the strange behavior
            // where dataprocessor is called for the new data and then the onRequestComplete is called for the old
            // request, making it difficult for consumers of this API to take appropriate action.
            // If we call cancelRequest now, the onRequestComplete handler will be called immediately and not again
            // later.
            fetcher.cancelRequest();

            if (typeof options.dataprocessor === 'function') {
                data = options.dataprocessor(data);
            }

            fetcher.sendRequest(data, false);

            $clear.toggle(value.length != 0);
            $noResults.hide();
            $wrapper.css({display: $wrapperContainer.children().length > 0 ? '' : 'none'});
        }


        function onFocusHandler(e) {
            if (!skipFocusHandler)
                onValueChange($input.val());
        }

        function onClickTapHandler(e) {
            if (!isSuggestionVisible())
                onValueChange($input.val());
        }

        function onBlurHandler(e) {
            fetcher.cancelRequest();
        }

        function onKeyupHandler(e) {

        }

        function onKeydownHandler(e) {
            var $selected;
            var input = $input[0];


            if (!isSuggestionVisible()) {
                if (e.keyCode === KEY_ENTER) {
                    onValueChange($input.val());
                    shouldAttemptAutoSelect = true;
                }
                return;
            }

            // suggestions navigation.
            if (e.keyCode === KEY_ESCAPE) {
                restoreInput();
                setVisibility(false);
            }

            if ($lines && (e.keyCode === KEY_UP || e.keyCode === KEY_DOWN)) {
                // select next element
                $selected = getSelected();
                if ($selected.length) {
                    setSelected((e.keyCode === KEY_UP) ? $selected.prev(':visible') : $selected.next(':visible'));
                } else {
                    setSelected((e.keyCode === KEY_UP) ? $lines.filter(':visible').last() : $lines.filter(':visible').first());
                }

                watcher.stopWatch();
                // if no selection. restore user's input
                if (getSelected().length) {
                    updateInputWithSelected(false);
                } else {
                    restoreInput();
                    input.setSelectionRange(input.value.length, input.value.length);

                }
                watcher.startWatch();
                input.focus();
                e.preventDefault();

            } else if (e.keyCode === KEY_BACKSPACE) {
                setTimeout(function () {
                    $input.trigger('input');
                }, 1); // IE 9 doesn't trigger 'input' event on backspace
            } else if (e.keyCode === KEY_ENTER || e.keyCode === KEY_TAB) {
                if (fireSelected(e))
                    return;

                if (!options.autosubmit && isSuggestionVisible()) {
                    applySelected();
                    e.preventDefault();
                } else {
                    fetcher.cancelRequest();
                }
            }
        }

        $(function () {
            $clear = $(options.clearSelector).hide();
            $input = $(inputSelector);
            $form = $input.closest('form');
            $viewAll.on('click', function (e) {
                e.preventDefault();
                $form.submit();
                setVisibility(false);
            });

            if ($input.length) {
                if (options.customWrapper === null) {
                    $wrapper = $('<div class="b-autocomplete"></div>');
                } else {
                    $wrapper = $(options.customWrapper);
                    $wrapperContainer = $wrapper.find(CONTAINER_SELECTOR);
                }

                if (options.zindex !== null) {
                    $wrapper.css('zIndex', options.zindex + globalAutocompleteCounter);
                }

                $wrapper
                    .attr('id', autocompleteContainerId)
                    .hide()
                    .appendTo('body');
                $wrapper.trigger('appended');

                $wrapper.on('click', AUTOCOMPLITE_LINE_SELECTOR, function (ev) {
                    if (typeof selectedHandler === 'function') {
                        skipFocusHandler = true;
                        setTimeout(function () {
                            skipFocusHandler = false;
                        }, 1000);
						if (options.autoApply) {
							selectedHandler(getSelected(ev));
							applySelected();
							$input.focus();
							return;
						}
                        if (!selectedHandler(getSelected(ev))) {
                            return;
                        }
                    }
                    if (options.changeLocation === true) {
                        changeLocation(ev);
                    } else if (options.autosubmit) {
                        $form.submit();
                    }
                });

                $input.on('keydown' + AUTOCOMPLETE_NAMESPACE, onKeydownHandler);
                $input.on('keyup' + AUTOCOMPLETE_NAMESPACE, onKeyupHandler);
                $input.on('focus' + AUTOCOMPLETE_NAMESPACE, onFocusHandler);
                $input.on('click tap' + AUTOCOMPLETE_NAMESPACE, onClickTapHandler);
                $input.on('blur' + AUTOCOMPLETE_NAMESPACE, onBlurHandler);
                $input.parents('form:first').on('submit' + AUTOCOMPLETE_NAMESPACE, function (e) {
                    if (isSuggestionVisible()) {
                        applySelected();
                    }
                });

                watcher = new wgsdk.InputWatcher($input, null, onValueChange, options.postprocessor);
                if (typeof(url) === 'function') {
                    fetcher = new wgsdk.NoAjaxFetcher(url, null, onRequestComplete);
                } else {
                    fetcher = new wgsdk.AjaxFetcher({'url': url}, null, onRequestComplete, 100);
                }

            }

            $(options.clearSelector).on('click', function (e) {
                e.preventDefault();
                $input.val('').focus().trigger('input');
                $clear.hide();
                setVisibility(false);

                if (typeof clearHandler === 'function') {
                    clearHandler();
                }
            });


        });

        // API
        return {
            'setVisibility': setVisibility,
            'preventAutocomplete': preventAutocomplete,
            'destroy': destroy
        };
    };
})(jQuery, WXP_HELPERS_MODULE = {}, wgsdk);
